import React, { useEffect } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../components/Buttons';
import Hr from '../../components/Hr';
import OrderSummaryContainer from '../OrderSummary/OrderSummaryContainer';

import DynamicCartIconContainer from '../DynamicCartIcon/DynamicCartIconContainer';
import OrderSettingSummaryContainer from '../OrderSetting/OrderSettingSummary/OrderSettingSummaryContainer';
import Alert from '../Alert/Alert';
import useCart from '../../customHooks/useCart';
import appConfig from '../../../app-config';
import { guestInfoClients } from '../../clientCustomizations';
import { navigate } from 'gatsby';

const Wrapper = styled.div`
  display: grid;
  grid-gap: 28px;
  max-width: 700px;
  margin: auto;
  margin-top: 0;
  position: sticky;
  top: 170px;
  margin-top: 24px;

  @media (max-width: 1100px) {
    display: none;
  }
`;

const Card = styled.div`
  display: grid;
  grid-gap: 24px;
  align-content: flex-start;
  max-width: 700px;
  background-color: ${(props) => props.theme.cartPreviewSidebarBackgroundColor};
  border-radius: 10px;
  padding: 20px;
  overflow: auto;
  height: calc(100vh - 190px);
  @media (max-width: 786px) {
  }
`;

const CustomHr = styled(Hr)`
  @media (min-width: 768px) {
    margin: 0 -20px;
  }
`;

const ReviewOrderButton = styled(PrimaryButton)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin-top: 0;
  min-width: 264px;
  width: 264px;
  height: 48px;
  font-size: 17px;
  background-color: ${(props) => props.theme.reviewOrderButtonBackgroundColor};

  &:hover {
    background-color: ${(props) =>
      props.theme.reviewOrderButtonHoverBackgroundColor};
  }
`;

const CartIconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
`;

const Price = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
`;
const CartMenuSidebar = ({
  showReviewOrderButton,
  reviewOrder,
  totalCartPriceBeforeTax,
  productsInCart,
  isFoodRequired,
  createAlert,
  minFoodPrice,
  updateCartScreen,
}) => {
  useCart();
  const handleReviewButtonClick = () => {
    if (guestInfoClients.includes(appConfig.appSource)) {
      updateCartScreen('customer-info');
      navigate('/cart');
    } else {
      updateCartScreen('review');
      reviewOrder();
    }
  };

  useEffect(() => {
    if (isFoodRequired)
      createAlert({
        type: 'error',
        message: `By law, alcohol must be purchased with food (min ${minFoodPrice}) when ordering from restaurants.`,
      });
  }, [isFoodRequired]);

  return (
    <div style={{ position: 'relative' }}>
      <Wrapper>
        <Card>
          <OrderSettingSummaryContainer cartMenuSidebar={true} />
          <CustomHr />
          <OrderSummaryContainer productsInCart={productsInCart} />
        </Card>
        {showReviewOrderButton && (
          <ReviewOrderButton onClick={handleReviewButtonClick}>
            <CartIconWrapper>
              <DynamicCartIconContainer />
            </CartIconWrapper>
            {isFoodRequired ? 'Food is Required' : 'Review Order'}
            <Price>{totalCartPriceBeforeTax}</Price>
          </ReviewOrderButton>
        )}
        <Alert />
      </Wrapper>
    </div>
  );
};

export default CartMenuSidebar;
